import { isDevelopment } from '~/utils/misc'
import { ClientOnly } from 'remix-utils/client-only'
import ReactPannellum from 'react-pannellum'
import Move from './icon/move'

interface PanoramicProps {
  panoramic: {
    id: string
    title?: string
    width?: string
    height?: string
    image: { asset: { sys: { uri: string } } }
    autoRotate?: boolean
    hfov?: number
    pitch?: number
    yaw?: number
    className?: string
  }
  inView?: boolean
}

const Panoramic = (props: PanoramicProps) => {
  const {
    id,
    title,
    width,
    height,
    image,
    autoRotate,
    hfov,
    pitch,
    yaw,
    className
  } = props.panoramic
  const inView = props?.inView

  const config = {
    id: id,
    title: title,
    autoLoad: true,
    showControls: false,
    mouseZoom: false,
    keyboardZoom: false,
    showZoomCtrl: false,
    friction: 0.1,
    autoRotate: autoRotate ? -2 : 0,
    autoRotateInactivityDelay: autoRotate ? 2000 : 0,
    hfov: hfov || 100,
    pitch: pitch || -15,
    yaw: yaw || 0
  }

  if (inView)
    return (
      <ClientOnly>
        {() => (
          <div className='relative h-full w-full'>
            <ReactPannellum
              id={id}
              sceneId={id}
              type='equirectangular'
              imageSource={`${
                isDevelopment && !image?.asset.sys.uri.startsWith('https')
                  ? 'https://preview-websitemodern-uni-hull.cloud.contensis.com'
                  : ''
              }${image.asset.sys.uri}?f=webp&h=1200`}
              config={config}
              style={{
                width: width || '100%',
                height: height || '100%'
              }}
              className={className}
            />

            <div className='tag bg-pink py-2xs px-xs gap-2xs unstyled-link top-s right-s absolute inline-flex max-w-[350px] items-center rounded-full font-mono tracking-normal transition-colors hover:no-underline focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 focus:outline-hidden'>
              <Move />
              Look around
            </div>
          </div>
        )}
      </ClientOnly>
    )
}

export default Panoramic
